import {
  ADD_SUPPRESS_EMAIL_REQUEST,
  ADD_SUPPRESS_EMAIL_SUCCESS,
  ADD_SUPPRESS_EMAIL_FAILURE,
  DELETE_SUPPRESS_EMAIL_REQUEST,
  DELETE_SUPPRESS_EMAIL_SUCCESS,
  DELETE_SUPPRESS_EMAIL_FAILURE,
  LIST_SUPPRESS_EMAILS_REQUEST,
  LIST_SUPPRESS_EMAILS_SUCCESS,
  LIST_SUPPRESS_EMAILS_FAILURE,
} from '../actions/supressEmailActions';

const initialState = {
  loading: false,
  adding: false,
  deleting: false,
  list: [],
  error: null,
  pagination: {
    totalCount: 0,
    page: 1,
    limit: 25,
  },
};

export default function supressEmailReducer(state = initialState, action) {
  switch (action.type) {
    case LIST_SUPPRESS_EMAILS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case LIST_SUPPRESS_EMAILS_SUCCESS: {
      const payload = action.payload || {};
      // Handle different response structures
      const dataList = Array.isArray(payload)
        ? payload
        : (payload.data && Array.isArray(payload.data))
          ? payload.data
          : (payload.list && Array.isArray(payload.list))
            ? payload.list
            : (payload.emails && Array.isArray(payload.emails))
              ? payload.emails
              : [];

      const totalCount = payload.totalCount || payload.total || payload.count || dataList.length || 0;
      const page = payload.page || state.pagination.page;
      const limit = payload.limit || state.pagination.limit;

      return {
        ...state,
        loading: false,
        list: dataList,
        pagination: {
          totalCount,
          page,
          limit,
        },
        error: null,
      };
    }

    case LIST_SUPPRESS_EMAILS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error || 'Failed to fetch suppress emails',
      };

    case ADD_SUPPRESS_EMAIL_REQUEST:
      return {
        ...state,
        adding: true,
        error: null,
      };

    case ADD_SUPPRESS_EMAIL_SUCCESS:
      return {
        ...state,
        adding: false,
        error: null,
      };

    case ADD_SUPPRESS_EMAIL_FAILURE:
      return {
        ...state,
        adding: false,
        error: action.error || 'Failed to add suppress email',
      };

    case DELETE_SUPPRESS_EMAIL_REQUEST:
      return {
        ...state,
        deleting: true,
        error: null,
      };

    case DELETE_SUPPRESS_EMAIL_SUCCESS: {
      // Remove the deleted email from the list
      const updatedList = state.list.filter(
        (email) => email._id !== action.payload.id && email.id !== action.payload.id
      );
      return {
        ...state,
        deleting: false,
        list: updatedList,
        pagination: {
          ...state.pagination,
          totalCount: Math.max(0, state.pagination.totalCount - 1),
        },
        error: null,
      };
    }

    case DELETE_SUPPRESS_EMAIL_FAILURE:
      return {
        ...state,
        deleting: false,
        error: action.error || 'Failed to delete suppress email',
      };

    default:
      return state;
  }
}

